module.exports = __webpack_public_path__ + "static/media/Yannick - ZFE 55 - 1ère.354fb250.mp3";